<h3 class="mat-dialog-title mb-2">
  Prescribed Drug
  <button (click)="closeDialog()" type="button" class="float-end btn btn-sm">
    <mat-icon>close</mat-icon>
  </button>
</h3>
<div class="margin-button-4">
  <div class="row">
    <div class="col-md-6 col-6 b-r bg-tb-header">
      <strong>Drug</strong>
      <br />
      <p class="text-muted">{{drug.DrugName}}</p>
    </div>
    <div class="col-md-6 col-6 b-r bg-tb-header">
      <strong>Description</strong>
      <br />
      <p class="text-muted">{{drug.Description}}</p>
    </div>
  </div>
</div>
<h3 class="mat-dialog-title mb-2">Replace With</h3>
<form [formGroup]="replaceDrugForm" (ngSubmit)="ReplaceDrug()">
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <strong>Drug*</strong>
      <br />
      <!-- <p class="text-muted">Drug 1</p> -->
      <!-- <mat-form-field class="example-full-width" appearance="outline">
      <mat-label class="margin-button-3">Drug</mat-label>
      <input matInput formControlName="qualification" />
    </mat-form-field> -->
      <mat-form-field class="example-full-width" appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Search drug *"
          formControlName="drugName"
          [matAutocomplete]="auto2"
          required
        />
        <mat-autocomplete
          #auto2="matAutocomplete"
          (optionSelected)="selectedDrug($event)"
          [displayWith]="displayFn2"
        >
          <mat-option
            *ngFor="let drug of filteredDrugs$ | async"
            [value]="drug"
          >
            <span class="text-uppercase">{{ drug.Name }}</span>
          </mat-option>
        </mat-autocomplete>
        <mat-error *ngIf="replaceDrugForm.get('drugName').hasError('required')">
          Drug is required
        </mat-error>
      </mat-form-field>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <strong>#Refill</strong>
      <br />
      <mat-form-field class="example-full-width" appearance="outline">
        <input
          [max]="10"
          [min]="0"
          type="number"
          matInput
          formControlName="refill"
          placeholder="No Of Refill"
        />
        <mat-error *ngIf="replaceDrugForm.get('refill').hasError('min')">
          #Refill should be greater than or equal to 0
        </mat-error>
        <mat-error *ngIf="replaceDrugForm.get('refill').hasError('max')">
          #Refill should be less than or equal to 10
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6">
      <strong>Sig Code</strong>
      <br />
      <mat-form-field class="example-full-width" appearance="outline">
        <input
          matInput
          type="text"
          placeholder="Sig Code"
          formControlName="codeName"
          [matAutocomplete]="auto3"
        />
        <mat-autocomplete
          #auto3="matAutocomplete"
          (optionSelected)="selectedPrescriptionCode($event)"
          [displayWith]="displayFn3"
        >
          <mat-option
            *ngFor="let code of filteredPrescriptionCode$ | async"
            [value]="code"
          >
            <span class="text-uppercase"
              >{{ code.Code }} | {{ code.Description }}</span
            >
          </mat-option>
        </mat-autocomplete>
      </mat-form-field>
    </div>

    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 b-r">
      <strong>Description*</strong>
      <br />
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label class="margin-button-3">Description</mat-label>
        <input
          [maxLength]="100"
          required
          matInput
          formControlName="description"
        />
        <mat-error
          *ngIf="replaceDrugForm.get('description').hasError('required')"
        >
          Description is required
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="row">
    <div class="col-xl-6 col-lg-6 col-md-6 col-sm-6 b-r">
      <strong>Remark*</strong>
      <br />
      <mat-form-field class="example-full-width" appearance="outline">
        <mat-label class="margin-button-3">Remark</mat-label>
        <input [maxLength]="100" matInput formControlName="remark" required />
        <mat-error *ngIf="replaceDrugForm.get('remark').hasError('required')">
          Remark is required
        </mat-error>
      </mat-form-field>
    </div>
  </div>
  <div class="justify-content-end row">
    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
      <button class="btn btn-lg btn-primary w-100" type="submit">
        Replace
      </button>
    </div>

    <div class="col-xl-2 col-lg-2 col-md-2 col-sm-2 mb-2">
      <button class="btn btn-lg btn-secondary w-100" type="reset">
        Reset
      </button>
    </div>
  </div>
</form>
